import tw from 'twin.macro';

export const InfoWrapper = tw.div` flex flex-col justify-start items-start font-primary
                                
`;
